import {Grid} from 'focus-manager/web';
import * as React from 'react';

import keys from '../Constants/keys';
import createNextValue from '../Util/createNextValue';

import Key from './Key';

class Keyboard extends React.Component {
    public state = {
        value: '',
    };

    public render(): React.ReactNode {
        return (
            <>
                <div className="value">{this.state.value}</div>
                <Grid className="keyboard" columns={11} loop>
                    {keys.map(key => (
                        <Key {...key} key={key.value} onSelect={this.handleKeySelect.bind(this, key.value)} />
                    ))}
                </Grid>
            </>
        );
    }

    private handleKeySelect(keyValue: string): void {
        const nextValue = createNextValue(this.state.value, keyValue);

        this.setState({
            value: nextValue,
        });
    }
}

export default Keyboard;
